import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center justify-center flex-wrap md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col items-center md:flex-row justify-between" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_9 = { class: "max-w-full overflow-x-auto" }

import { inject, onMounted, ref, computed, watch } from "vue";
import { AxiosInstance } from "axios";
import Navbar from "@/components/tools/Navbar.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { useRoute } from "vue-router";
import DataTable from "@/components/tools/DataTable.vue";
import stringify from "qs-stringify";
import "dayjs/locale/th";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { formatNumber, translate } from "@/utils/tools";
import { SearchIcon } from "@heroicons/vue/solid";
import SubEventEdit from "../../components/dialogs/SubEventEdit.vue";
import SubEventCreateDialog from "../../components/dialogs/SubEventCreateDialog.vue";
import SubEventFilterDialog from "@/components/dialogs/SubEventFilterDialog.vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'SubEvent',
  setup(__props) {

dayjs.extend(localizedFormat);

const axios = inject("$axios") as AxiosInstance;
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref<boolean>(false);
const createSubEventModal = ref<boolean>(false);
const editSubEventModal = ref<boolean>(false);
const selectedRow = ref({});
const store = useStore();
const columns = ref([
  {
    label: translate("messages.event.subName"),
    field: "name",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.event.providerName"),
    field: "providers",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.event.targetSettleAmount"),
    field: "target_settle_amount",
    class: () => "w-32 flex flex-wrap",
    // isSorted: false,
    // sort: true,
  },
  {
    label: translate("messages.event.targetSettleCount"),
    field: "target_settle_count",
    class: () => "w-32 flex flex-wrap",
    // isSorted: false,
    // sort: true,
  },
  {
    label: translate("messages.event.targetValidAmount"),
    field: "target_valid_amount",
    class: () => "w-32 flex flex-wrap",
    // isSorted: false,
    // sort: true,
  },
  {
    label: translate("messages.event.targetRoundCount"),
    field: "target_round_count",
    class: () => "w-32 flex flex-wrap",
    // isSorted: false,
    // sort: true,
  },
  {
    label: translate("messages.event.action"),
    field: "action",
    align: "center",
    isToggle: true,
    function: async (data: any) => {
      // data.is_active = !data.isActivate;
      await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/sub-events/updateActive`,
        { id: data.id, is_active: !data.is_active },
        {
          headers: {
            "x-cm-operator-id": store.state.selectedOperator.operatorId,
          },
        }
      );
      await fetchPageData();
    },
  },
  {
    label: "",
    field: "",
    isEdit: true,
    sort: false,
  },
  {
    label: "",
    field: "delete_sub_event",
    align: "center",
    isFunction: true,
    permission: "QUEST_EVENT.DELETE",
    class: () =>
      "cursor-pointer inline-flex border border-transparent rounded-md  bg-red-500 hover:bg-red-600 text-white bg-red-500 hover:bg-red-600 ",
    function: (data: any) => deleteSubEvent(data),
  }
]);

const pageConfig = ref({
  page: 1,
  dataLength: 0,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  search: "",
  sort: [["seq_num", "DESC"]],
});

const filterForm = ref({
  name: undefined,
  providers: undefined,
});

const fetchPageData = async (_reset = false) => {
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { name, providers } = filterForm.value;

  const payload = {
    page: page,
    name: search || name || null,
    providers: providers || null,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
    event_id: route.params.id,
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/sub-events/list`;
  const rows = await axios
    .post(url, payload, {
      headers: {
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
      },
    })
    .then(({ data }) => data.rows)
    .catch(err => {
      isLoaded.value = true;
    });

  const newArray = rows.map((obj: any) => {
    return {
      ...obj,
      target_settle_amount: obj.config[0].target_settle_amount,
      target_settle_count: obj.config[0].target_settle_count,
      target_valid_amount: obj.config[0].target_valid_amount,
      target_round_count: obj.config[0].target_round_count,
      delete_sub_event: "Delete",
    };
  });

  // console.log("rows : ", newArray);

  dataRows.value = newArray;

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };

  selectedRow.value = {};

  /** update url to persist page config */
  window.history.replaceState({}, document.title, `?${stringify({ page, rowsPerPage })}`);
  isLoaded.value = true;
};

const deleteSubEvent = async (data: any) =>{
  if (confirm(`Are you sure you want to delete sub event this Name? (Name: ${data.name})`)) {
    try{
      isLoaded.value = false;
      await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/sub-events/delete`,
        { id: data.id },
        {
          headers: {
            "x-cm-operator-id": store.state.selectedOperator.operatorId,
          },
        }
      );
      await fetchPageData();
    }catch(error){
      alert(error?.response?.data?.message);
    }finally{
      isLoaded.value = true;
    }
  }
};

const edit = (e: any) => {
  selectedRow.value = {
    ...e,
    target_settle_amount: e.config[0].target_settle_amount,
    target_settle_count: e.config[0].target_settle_count,
    target_valid_amount: e.config[0].target_valid_amount,
    target_round_count: e.config[0].target_round_count,
  };
  editSubEventModal.value = true;
};

const doSort = (attName: string) => {
  console.log("attName : ",attName)
  // not working
  const index = columns.value.findIndex((column) => column.label === attName);
  if (!columns.value[index].sort) {
    return;
  }

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  let formattedAttName;
    if (attName.toLocaleLowerCase() === "provider") formattedAttName = "providers";
    if (attName === "Target Settle Amount") formattedAttName = "target_settle_amount";
  sort[0] = [formattedAttName || attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];
  fetchPageData(true);
};

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);
onMounted(() => {
  // console.log("route.query : ", route.params.id);
  // pageConfig.value.page = Number(route.query.page) || 1;
  // pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.event.subEvent')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              type: "search",
              name: "search",
              placeholder: _ctx.$t('messages.event.search'),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchPageData(true)), ["enter"]))
            }, null, 40, _hoisted_7), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (advanceFilterModal.value = true)),
          class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-white mr-2",
            icon: ['far', 'filter'],
            transform: ""
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.event.advanceFilter")), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (createSubEventModal.value = true)),
          class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, _toDisplayString(_ctx.$t("messages.event.createSubEvent")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(DataTable, {
        columns: columns.value,
        data: dataRows.value,
        onSort: doSort,
        onEdit: edit,
        isLoaded: isLoaded.value
      }, null, 8, ["columns", "data", "isLoaded"])
    ]),
    _createVNode(Pagination, {
      config: pageConfig.value,
      "onUpdate:config": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig).value = $event))
    }, null, 8, ["config"]),
    _createVNode(SubEventEdit, {
      show: editSubEventModal.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((editSubEventModal).value = $event)),
      form: selectedRow.value,
      onEdited: _cache[6] || (_cache[6] = ($event: any) => (fetchPageData())),
      onClosed: _cache[7] || (_cache[7] = ($event: any) => (fetchPageData()))
    }, null, 8, ["show", "form"]),
    _createVNode(SubEventFilterDialog, {
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[9] || (_cache[9] = ($event: any) => ((filterForm).value = $event)),
      onFilter: _cache[10] || (_cache[10] = ($event: any) => (fetchPageData()))
    }, null, 8, ["show", "form"]),
    _createVNode(SubEventCreateDialog, {
      show: createSubEventModal.value,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((createSubEventModal).value = $event)),
      event_id: _unref(route).params.id,
      "onUpdate:event_id": _cache[12] || (_cache[12] = ($event: any) => ((_unref(route).params.id) = $event)),
      onCreated: _cache[13] || (_cache[13] = ($event: any) => (fetchPageData()))
    }, null, 8, ["show", "event_id"])
  ], 64))
}
}

})